var modal = document.querySelector(".b-header-modal");
var trigger = document.querySelector(".b-header__search");
var body = document.querySelector("body");
function toggleModal() {
    modal.classList.toggle("show-modal");
    body.classList.toggle('fixed');
}

function windowOnClick(event) {
    if (event.target === modal) {
        toggleModal();
    }
}

trigger.addEventListener("click", toggleModal);
window.addEventListener("click", windowOnClick);


// WEBPACK FOOTER //
// ./src/js/general/header-modal.js